import { Options } from "@components/modules/Table/types"
import { useEffect, useMemo } from "react"
import { Row } from "react-table"

export default function useResourceTableOptions<T extends ObjectWithId>(
    actions: Options<T>["actions"] = [], 
    edit: (row: Row<T>) => void, 
    add: () => void,
    heading: Options<T>["heading"]
) {
    return useMemo(() => ({
        heading,
        actions: [{ label: "Edit", action: edit }, ...actions], add
    }), [edit, add]) as Options<T>
}